var render = function render(){var _vm=this,_c=_vm._self._c;return _c('caption-text',{staticClass:"inactive-text"},[_vm._v(" ©"+_vm._s(_vm.year)+" "+_vm._s(_vm.logoLabel)+". "+_vm._s(_vm.$t("humanoo.rights")))])
}
var staticRenderFns = []

export { render, staticRenderFns }